export default __webpack_public_path__ + "static/media/searchIcon.f711d54c.svg";